export default __webpack_public_path__ + "static/media/Notice-sprite.8e91acee.svg";